import { useEffect, useState } from "react";
import { RootState, useAppDispatch } from "../../../redux/store";
import { useSelector } from "react-redux";
import { LogisticaTiposFormaPago, Docs } from "@pcgerente-node/pcg-comun";
import { conseguirManifiestosDetallesEnRutas } from "../../../redux/actions/actionsLiquidacionRutas";
import Loading from "../../helpers/Loading/Loading";
import CardsManifiestosDetallesEnRuta from "../CardLiquidacionRuta/CardLiquidacionRuta";
import "../../../styles/consultaGuia.css"

const LiquidacionDeRutasContent = () => {

  const store = useSelector((state: RootState) => state.liquidacionRutas.guiasEnRuta)
  const usuarioVM = useSelector((state: RootState) => state.auth.usuarioActual)
  const usuario = usuarioVM._ItemActivo
  
  const ManifiestosDetallesStore = store.info
  const [busquedaNumeroGuia, setBusquedaNumeroGuia] = useState("");
  const [datosFiltrados, setDatosFiltrados] = useState<typeof ManifiestosDetallesStore>([]);

  const dispatch = useAppDispatch()

  useEffect(() => {
    buscarManifiestosDetallesEnRuta();
  },[]);

  useEffect(() => {
    setDatosFiltrados(ManifiestosDetallesStore ? ManifiestosDetallesStore : []);
  }, [ManifiestosDetallesStore]);

  return (
    <div id="content" className="main-content">
      <div className="layout-px-spacing mt-4">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div className="col-sm-12 text-center">
            <h3 style={{color: "black"}}>Liquidación de Guías</h3>
          </div>
          <div className="col-12 d-flex flex-column align-items-center mt-4">
            <div className="mb-3 col-xl-4 col-lg-7 col-md-9 col-sm-11 col-12">
              <input
                type="text"
                className="form-control"
                placeholder="Buscar por número de documento"
                value={busquedaNumeroGuia}
                onChange={e => handleBusquedaPorNumero(e.target.value)}
                disabled={store.loading}
              />
            </div>
            <div className="d-flex w-100 justify-content-center">
              <button
                className="btn btn-primary col-xl-4 col-lg-7 col-md-9 col-sm-11 col-12"
                onClick={() => {
                  setBusquedaNumeroGuia("");
                  buscarManifiestosDetallesEnRuta()
                }}
                disabled={store.loading}
              >
                Actualizar
              </button>
            </div>
          </div>
        </div>

        <div className="layout-spacing mh-100">
          <div className="widget-content">
            <div className="d-flex justify-content-center mt-2 mb-2">
              <span className="text-danger" style={{fontSize: "1.2rem"}}>{store.errorUndefined??""}</span>
            </div>
            {
              (store.loading)?
               <div className="m-5">
                 <Loading />
               </div>
               :<CardsManifiestosDetallesEnRuta manifiestosDetalles={datosFiltrados}/>
            }
          </div>
        </div>
      </div>
    </div>
  )

  function buscarManifiestosDetallesEnRuta() {
      const defaultSearch = {
          desde: "",
          hasta: "",
          idDocumento: Docs.TODOS,
          nombreDestinatario: "",
          numeroDocumento: 0,
          tipo: LogisticaTiposFormaPago.Todos,
          /**
           * Este campo es un bit en la base de datos, por lo que se setea <code>2</code>
           * para considerar todos los casos
           */
          tipoEntrega: 2, //Todos
          permiteEntregarConManifiesto: 2, //Todos
      }

      dispatch(conseguirManifiestosDetallesEnRutas(
        defaultSearch.desde,
        defaultSearch.hasta,
        defaultSearch.idDocumento,
        defaultSearch.nombreDestinatario,
        defaultSearch.tipoEntrega,
        defaultSearch.tipo,
        defaultSearch.permiteEntregarConManifiesto,
        defaultSearch.numeroDocumento,
        usuario.idConductor!!
      ))
  }

  function handleBusquedaPorNumero(value: string) {
    const isNumeric = /^\d+$/.test(value);
    if (! isNumeric && value !== "")
      return;

    setBusquedaNumeroGuia(value);

    if(!value){
      setDatosFiltrados(ManifiestosDetallesStore)
      return;

    } else{
      const filtrados = ManifiestosDetallesStore.filter(md => {
        const numeroDocumentoGuia: string = md.logistica_GUIA!!.numeroDocumento.toString();
        return numeroDocumentoGuia.includes(value)
      });

      setDatosFiltrados(filtrados);
    }
  }
}


export default LiquidacionDeRutasContent